<template>
  <dialog-form
    id="formAddRelationGroup"
    :value="value"
    @input="$emit('input', $event)"
    @commit="save"
    :title="$localize('AddRelationGroup.title')"
    :allow-continue="false"
    :loading="loading"
  >
    <v-text-field
      class="inputName"
      :label="$localize('RelationGroup.name')"
      v-model="name"
      :rules="[validation.required, validation.maxLength(20)]"
    />
  </dialog-form>
</template>

<script>
import DialogForm from "@/shared/components/DialogForm";
import sendCommand from "@/services/sendCommand";
import { required, maxLength } from "@/services/validation";
export default {
  components: { DialogForm },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      name: "",
      validation: { required, maxLength },
    };
  },
  methods: {
    async save(callback) {
      const result = await sendCommand("AddRelationGroup", {
        name: this.name,
      });
      if (result.success) {
        this.$emit("saved");
      }
      callback({ success: result.success });
    },
  },
};
</script>

